import { LoadSpinner } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import React, { useState } from 'react'

import { BottomSheet, Card, LineItem } from '@/components'
import { UpdateInstructionForm } from '@/forms/UpdateInstructionForm'
import { PropertyQueries } from '@/graphql/queries/property.queries'
import { useToggle } from '@/hooks'
import { AccessLevel, useAccessLevel } from '@/hooks/useAccessLevel'
import { useGraphql } from '@/hooks/useGraphql'
import { AccessInstruction } from '@/types/Homes'
import { ReservationProperty } from '@/types/Property'
import { AccessInstructions } from '@/views/AccessInstructions/AccessInstructions'

export const PropertyAccess = ({ propertyId }: { propertyId: number }) => {
  const {
    data: propertyData,
    isLoading,
    refetch,
  } = useGraphql<{ property: ReservationProperty }>(
    PropertyQueries.QUERY_KEYS.getReservationProperty,
    PropertyQueries.getReservationProperty(),
    { id: propertyId },
    {
      enabled: !!propertyId,
    },
  )

  const propertyAccessInstructions = propertyData?.property.accessInstructions || []

  const { AGM, HUB_MANAGER } = AccessLevel
  const { accessGranted } = useAccessLevel()
  const isEditable = accessGranted([AGM, HUB_MANAGER])
  const [editInstruction, setEditInstruction] = useState<AccessInstruction>()
  const { isShown: showModal, toggle: toggleModal } = useToggle()

  const handleEditInstruction = (instruction: AccessInstruction) => {
    setEditInstruction(instruction)
    !showModal && toggleModal()
  }

  const handleCloseModal = () => {
    setEditInstruction(undefined)
    toggleModal()
  }

  return (
    <>
      {isLoading ? (
        <div className="flex h-120 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          <AccessContainerStyled>
            {propertyData && (
              <>
                <Card cardClassName="mb-4" headerText="General" minimizable={true}>
                  <div className="flex w-full flex-col px-4">
                    <LineItem
                      label="Trash Instructions"
                      value={propertyData.property?.trashInstructions || 'Unknown'}
                    />
                    <LineItem
                      label="Mail Box Instructions"
                      value={propertyData.property?.mailboxInstructions || 'Unknown'}
                    />
                  </div>
                </Card>
                {propertyAccessInstructions.length > 0 ? (
                  <AccessInstructions
                    data={propertyAccessInstructions}
                    handleEditInstruction={handleEditInstruction}
                    isEditable={isEditable}
                    isLoading={isLoading}
                  />
                ) : null}
              </>
            )}
          </AccessContainerStyled>
        </>
      )}

      <BottomSheet header="Update Instruction" isVisible={showModal} onClose={handleCloseModal}>
        {editInstruction && (
          <UpdateInstructionForm
            accessInstruction={editInstruction}
            closeModal={handleCloseModal}
            refetchOnSuccess={refetch}
          />
        )}
      </BottomSheet>
    </>
  )
}

export const AccessContainerStyled = styled.div`
  padding: 1rem 0;
  gap: 1.5rem;
`
